var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoBlack = function SvgInfoBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.4,
    d: "M6.334 3.666h1.333V5H6.334zm0 2.667h1.333v4H6.334zm.666-6A6.67 6.67 0 0 0 .333 7 6.67 6.67 0 0 0 7 13.666 6.67 6.67 0 0 0 13.667 7 6.67 6.67 0 0 0 7 .333m0 12A5.34 5.34 0 0 1 1.667 7 5.34 5.34 0 0 1 7 1.666 5.34 5.34 0 0 1 12.334 7 5.34 5.34 0 0 1 7 12.333"
  })));
};
export default SvgInfoBlack;